import React, { ReactElement, useState, useEffect, useCallback, useContext } from 'react';

import { forEach, keys } from 'lodash';
import accounting from 'accounting';
import TranslatorManager from 'ts-translate-js';
import tsRest from 'ts-rest-client';
import MarkDown from 'react-markdown';
import { MembershipTypeSaleInfoModel } from '../../../tsrestapi/models';
import { UUID } from 'crypto';
import { SiteCustomizationContext } from '../../../logic/reactcontext/site-customization-context';

type TotalFooterProps = {
    yourCumul: SelectionCumul;
    membershipTypeSaleInfos: { [key: UUID]: MembershipTypeSaleInfos }[];
    onMembershipTypeClick: (typeID: string) => void;
}

const tr = TranslatorManager.boundTR;

type MembershipTypeSaleInfos = {
    membershipTypeInfo: MembershipTypeSaleInfoModel;
    saving: number;
}

type SelectionCumul = {
    fees: number;
    total: number;
}

export function TotalFooter({ yourCumul, membershipTypeSaleInfos, onMembershipTypeClick }: TotalFooterProps): ReactElement {
    const [feesAndTaxesMessage, setFeesAndTaxesMessage] = useState<string>(null);

    const { siteSettings } = useContext(SiteCustomizationContext);
    
    const loadFeesAndTaxesMessage = useCallback(async (): Promise<string> => {
        const message = await tsRest.get("/integration/" + siteSettings.integ + "/feesandtaxesmessage");
        return message != null ? message[tsapp.twoLetterLang] : null;
    }, []);

    useEffect(() => {
        (async () => {
            setFeesAndTaxesMessage(await loadFeesAndTaxesMessage());
        })();
    }, [loadFeesAndTaxesMessage]);

    let membershipTypes = [];

    if (membershipTypeSaleInfos != null) {
        forEach(keys(membershipTypeSaleInfos), (typeID) => {
            let savingTotal: MembershipTypeSaleInfos = membershipTypeSaleInfos[typeID];
            if (savingTotal.saving > 0) {
                let messageAndlinkMembershipType = <div>
                    <MarkDown
                        className="markdown-inline"
                        source={tsapp.tr("ticketpriceselection.yoursaving", { amount: accounting.formatMoney(savingTotal.saving) })}
                    /> 
                        {/* TODO: Refactor this as a button */}
                        {/* eslint-disable-next-line sonarjs/anchor-is-valid */}
                        <a href="#" onClick={function () { onMembershipTypeClick(typeID); }.bind(this)}>
                        <strong>{savingTotal.membershipTypeInfo.name}</strong>
                    </a>
                </div>;

                membershipTypes.push(
                    <div key={typeID} className="alert alert-info">
                        <div className="text-right hidden-xs">
                            {messageAndlinkMembershipType}
                        </div>
                        <div className="visible-xs-block">
                            {messageAndlinkMembershipType}
                        </div>
                    </div>
                );
            }
        });
    }

    let membershipOnlyCtl = null;

    if (keys(membershipTypeSaleInfos).length > 0)
        membershipOnlyCtl = <div className="pull-left"><small><span id="lblMemberWarning">*{tsapp.tr("ticketpriceselection.membersonly")}</span></small></div>;

    let defaultFeesAndTaxesMessage = tr("Inclut des frais de") + " " + accounting.formatMoney(yourCumul.fees);
    if (feesAndTaxesMessage)
        defaultFeesAndTaxesMessage = feesAndTaxesMessage.replace("{fees}", accounting.formatMoney(yourCumul.fees));

    return <div className="footer">
        {membershipOnlyCtl}
        <ul className="list-inline text-right">
            <li className="">
                <strong>{tsapp.tr("ticketpriceselection.total")}</strong>
            </li>
            <li className="case-price accented-text">
                {accounting.formatMoney(yourCumul.total)}
            </li>
        </ul>
        <div className="row">
            <ul className="col-xs-12 list-unstyled pull-right text-right">
                <li style={{ paddingRight: "5px" }}>
                    <small>{defaultFeesAndTaxesMessage}</small>
                </li>
            </ul>
        </div>
        <ul className="list-unstyled">
            <li>
                {membershipTypes}
            </li>
        </ul>
    </div>;
}
